import { useEffect, useState } from 'react'
import './VpnGuard.css'

const CACHE_KEY = 'neurosfera_network_guard'
const API_URL = 'https://api.ipapi.is'
const VPN_GUARD_ENABLED = false

function isLocalHost() {
    return ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)
}

function readCachedResult() {
    try {
        const cached = sessionStorage.getItem(CACHE_KEY)
        return cached ? JSON.parse(cached) : null
    } catch {
        return null
    }
}

function writeCachedResult(result) {
    try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(result))
    } catch {
        // Session storage can be unavailable in strict privacy modes.
    }
}

function getBlockReason(data) {
    if (data?.is_vpn) return 'vpn'
    if (data?.is_proxy) return 'proxy'
    if (data?.is_tor) return 'tor'
    if (data?.is_datacenter) return 'datacenter'
    return ''
}

export default function VpnGuard() {
    const [blockReason, setBlockReason] = useState('')

    useEffect(() => {
        if (!VPN_GUARD_ENABLED) return undefined
        if (isLocalHost()) return undefined

        const cached = readCachedResult()
        if (cached?.checked) {
            setBlockReason(cached.blockReason || '')
            return undefined
        }

        const controller = new AbortController()
        const timer = window.setTimeout(() => controller.abort(), 4500)

        async function checkConnection() {
            try {
                const response = await fetch(API_URL, {
                    signal: controller.signal,
                    cache: 'no-store',
                })
                const data = await response.json()
                const reason = data?.error ? '' : getBlockReason(data)

                writeCachedResult({
                    checked: true,
                    blockReason: reason,
                })
                setBlockReason(reason)
            } catch {
                writeCachedResult({
                    checked: true,
                    blockReason: '',
                })
            } finally {
                window.clearTimeout(timer)
            }
        }

        checkConnection()

        return () => {
            window.clearTimeout(timer)
            controller.abort()
        }
    }, [])

    useEffect(() => {
        if (!blockReason) return undefined

        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'

        return () => {
            document.body.style.overflow = previousOverflow
        }
    }, [blockReason])

    if (!blockReason) return null

    return (
        <div className="vpnGuard" role="alert" aria-live="assertive">
            <div className="vpnGuard__blocker" aria-hidden="true" />
            <div className="vpnGuard__banner">
                <div className="vpnGuard__mark">!</div>
                <div className="vpnGuard__content">
                    <h2>Отключите VPN</h2>
                    <p>
                        Мы обнаружили защищённое или проксированное соединение. Отключите VPN, proxy или TOR,
                        чтобы сайт работал корректно.
                    </p>
                </div>
            </div>
        </div>
    )
}
